/**
 * Centralized business / brand configuration for F&T Renovations.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "F&T Renovations",
  shortName: "F&T Renovations",
  legalName: "F&T Renovations",
  owner: "Thomas Beaujon",
  tagline: "Remodeling & Painting Contractors in Metro Atlanta",
  description:
    "F&T Renovations is a Lawrenceville, GA remodeling and painting contractor with 6 years of hands-on experience. Painting, bathrooms, flooring, plumbing, electrical, Sheetrock, tile work, decks and basement finishing across Gwinnett, North Fulton and Hall County.",

  // TODO: confirm the live domain with the client before launch — used for
  // canonical URLs, sitemap entries and Open Graph tags.
  domain: "fandtrenovations.com",
  url: "https://fandtrenovations.com",

  phone: "(678) 431-1203",
  phoneHref: "tel:+16784311203",

  email: "fandtrenovations@gmail.com",
  emailHref: "mailto:fandtrenovations@gmail.com",

  address: {
    street: "681 Justins Place Lane",
    city: "Lawrenceville",
    state: "GA",
    stateFull: "Georgia",
    postalCode: "30043",
    country: "US",
    region: "Gwinnett County",
    serviceRadius: "35-mile",
    full: "681 Justins Place Lane, Lawrenceville, GA 30043",
  },

  hours: {
    summary: "Mon – Sat · 8 AM – 5 PM",
    days: "Monday – Saturday",
    time: "8:00 AM – 5:00 PM",
    closed: "Sunday — Closed",
    opens: "08:00",
    closes: "17:00",
    daysOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  },

  experience: {
    years: 6,
    label: "6 Years of Experience",
  },

  logo: "/ft-renovations-logo.png",
  logoLight: "/ft-renovations-logo-light.png",
  mark: "/ft-renovations-mark.png",
  ogImage: "/ft-renovations-og.png",
  favicon: "/ft-renovations-mark.png",

  social: {
    instagram: "https://www.instagram.com/fandtrenovations",
    instagramHandle: "@fandtrenovations",
    facebook: null,
    tiktok: null,
    yelp: null,
    bbb: null,
    google: null,
  },

  discount: {
    label: "10% Off Jobs Over $2,000",
    short: "10% Repeat & Referral Discount",
    description:
      "Returning customers and friends of past customers save 10% on any job over $2,000. Ask about it when you request your free estimate.",
  },

  /**
   * Third-party widget IDs — F&T Renovations' own LeadConnector and
   * Reputation Hub accounts.
   *
   * These drive the estimate form, the chat bubble and the reviews section.
   * Setting any of them back to `null` degrades gracefully rather than
   * breaking: the form falls back to a built-in email form, and the reviews
   * section falls back to a "leave the first review" invitation.
   */
  widgets: {
    chatWidgetId: "6a70cc400700923eba018508" as string | null,
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    reviewScriptSrc: "https://reputationhub.site/reputation/assets/review-widget.js",
    reviewIframeSrc:
      "https://reputationhub.site/reputation/widgets/review_widget/lRISJBJrLabXVjDNRXyo?widgetId=6a79c4cafdd615bbb1c0c19b" as
        | string
        | null,

    formIframeSrc: "https://link.systemic-digital.net/widget/form/uokAyAGgT4Lji0qCr4st" as
      | string
      | null,
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "uokAyAGgT4Lji0qCr4st" as string | null,
    formName: "Website Form",
    /** Initial iframe height; form_embed.js resizes it to fit once loaded. */
    formHeight: 684,
  },

  serviceAreas: [
    "Lawrenceville, GA",
    "Alpharetta, GA",
    "Johns Creek, GA",
    "Roswell, GA",
    "Buford, GA",
    "Suwanee, GA",
    "Flowery Branch, GA",
    "Duluth, GA",
    "Peachtree Corners, GA",
    "Lilburn, GA",
    "Norcross, GA",
    "Buckhead, Atlanta, GA",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
